import React from 'react';
import { LocalizedStrings } from '@src/utils/localizedStrings';
import { ActionButton, ActionProps } from '../ActionButton';

export function GetRightsButton(props: ActionProps) {
  return (
    <ActionButton
      {...props}
    >
      {lang.getRights}
    </ActionButton>
  );
}

const lang = LocalizedStrings({
  en: {
    getRights: 'Get rights',
  },
});
